import { Button, IconButton, Input, Tooltip, Typography } from "@mui/joy";
import { Box } from "@mui/system";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { AppConfig } from "../environement";
import { heightWithToolbar } from "../global";
import { usePro } from "../hooks/usePro/usePro";
import { setFormOpen } from "../reducers/rhapsody";
import { useMyMember } from "../redux/member/memberHooks";
import { useCreateAccessTokenMutation } from "../redux/verificationCode/verificationCodeHooks";

export default function ICSSUbscription() {
  const { member } = useMyMember();
  const dispatch = useDispatch();
  const [createAccessToken] = useCreateAccessTokenMutation();
  const [token, setToken] = useState("");
  const pro = usePro();
  let endpoint = "live";
  if (AppConfig.api.endpoint.includes("beta")) endpoint = "beta";
  if (AppConfig.api.endpoint.includes("demo")) endpoint = "demo";
  if (AppConfig.api.endpoint.includes("beta")) endpoint = "beta";

  const url = `https://ics.${endpoint}.rhapsody.la?token=${token}`;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          margin: "auto",
          maxWidth: 450,
          width: "100%",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | ICS Subscription</title>
        </Helmet>
        <img
          style={{ width: 450 }}
          src={"https://storage.googleapis.com/rhapsody/logos/ics.png"}
        />
        <Box>
          <Typography
            startDecorator={
              !pro ? (
                <Typography variant="outlined" color="info" level="body3">
                  PRO
                </Typography>
              ) : undefined
            }
            level="h6"
          >
            Your Personalized Calendar Subscription
          </Typography>
          <Typography>
            View all your Services in your favorite Calendar app. Always in sync
            with your Rhapsody account.
          </Typography>
        </Box>
        {token ? (
          <Input
            color="info"
            sx={{ width: "100%" }}
            readOnly
            endDecorator={
              <Tooltip title="Copy to Clipboard">
                <IconButton
                  color="info"
                  onClick={() => copyTextToClipboard(url)}
                >
                  <i className="fa-solid fa-copy"></i>
                </IconButton>
              </Tooltip>
            }
            // color="primary"
            value={url}
            size="lg"
          />
        ) : (
          <Button
            fullWidth
            color="info"
            endDecorator={<i className="fa-solid fa-rss"></i>}
            onClick={() => {
              if (!pro) {
                dispatch(setFormOpen({ isOpen: true, formID: "upgradeOpen" }));
              } else {
                createAccessToken({
                  name: "ICS Subscription",
                  validTo: "2092-01-08T00:00:00.000-07:00",
                })
                  .then((e: any) => {
                    setToken(e.data.token);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              }
            }}
          >
            Get Your ICS Subscription Link
          </Button>
        )}
      </Box>
    </>
  );
}

export function copyTextToClipboard(text: string) {
  navigator.clipboard.writeText(text).then(
    function () {
      console.log("");
    },
    function (err) {
      console.error("Async: Could not copy text: ", err);
    }
  );
}
